var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29298",
    "data-name": "Rectangle 29298",
    width: 14,
    height: 14,
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_693",
    "data-name": "Mask Group 693",
    clipPath: "url(#logout)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-09T113133.946",
    "data-name": "svgexport-6 - 2022-05-09T113133.946",
    transform: "translate(0 1.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11642",
    "data-name": "Group 11642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11641",
    "data-name": "Group 11641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11671",
    "data-name": "Path 11671",
    d: "M9.277,3.456v7.087A1.777,1.777,0,0,1,7.5,12.317H1.776A1.777,1.777,0,0,1,0,10.544V9.4a.351.351,0,1,1,.7,0v1.148a1.076,1.076,0,0,0,1.074,1.074H7.5a1.076,1.076,0,0,0,1.074-1.074V3.456A1.076,1.076,0,0,0,7.5,2.383H1.776A1.076,1.076,0,0,0,.7,3.456V4.6a.351.351,0,1,1-.7,0V3.456A1.777,1.777,0,0,1,1.773,1.683H7.5A1.775,1.775,0,0,1,9.277,3.456Z",
    transform: "translate(4.723 -1.683)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11672",
    "data-name": "Path 11672",
    d: "M8.886,9.641a.352.352,0,0,1-.5,0l-2.4-2.4a.348.348,0,0,1,0-.494l2.4-2.4a.349.349,0,0,1,.494.494l-1.8,1.8h6.565a.351.351,0,1,1,0,.7H7.087l1.8,1.8A.345.345,0,0,1,8.886,9.641Z",
    transform: "translate(-5.891 -1.683)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.db993caa96514c12dd2267deccabe01e.svg";
export { ForwardRef as ReactComponent };